const ADD_TENANT_INFORMATION = "ADD_TENANT_INFORMATION";
const ADD_WEBHOOKS = "ADD_WEBHOOKS";
const FETCH_WEBHOOKS = "FETCH_WEBHOOKS";
const ADD_USER_PROFILE = "ADD_USER_PROFILE";
const REMOVE_USER_PROFILE = "REMOVE_USER_PROFILE";
const VERIFY_EMAIL_FLAG = "VERIFY_EMAIL_FLAG ";
const REMOVE_WAREHOUSE = "REMOVE_WAREHOUSE";
const ADD_ANALYTICS = "ADD_ANALYTICS";
const UPDATE_ANALYTICS = "UPDATE_ANALYTICS";
const ADD_USER_STEPS = "ADD_USER_STEPS";
const UPDATE_TENANT_STATUS = "UPDATE_TENANT_STATUS";
const ADD_ENVIRONMENT = "ADD_ENVIRONMENT";
const UPDATE_COMPLIANCE_FORM_STATUS = "UPDATE_COMPLIANCE_FORM_STATUS";
const UPDATE_ENVIRONMENT_BASE_URL = "UPDATE_ENVIRONMENT_BASE_URL";
const UPDATE_PRODUCTION_KEY_STATUS = "UPDATE_PRODUCTION_KEY_STATUS";
const UPDATE_CREATOR_LINKAGE_MODULE_STATUS = "UPDATE_CREATOR_LINKAGE_MODULE_STATUS";

export {
  ADD_USER_PROFILE,
  ADD_TENANT_INFORMATION,
  REMOVE_USER_PROFILE,
  ADD_WEBHOOKS,
  FETCH_WEBHOOKS,
  VERIFY_EMAIL_FLAG,
  REMOVE_WAREHOUSE,
  ADD_ANALYTICS,
  UPDATE_ANALYTICS,
  ADD_USER_STEPS,
  ADD_ENVIRONMENT,
  UPDATE_COMPLIANCE_FORM_STATUS,
  UPDATE_TENANT_STATUS,
  UPDATE_ENVIRONMENT_BASE_URL,
  UPDATE_PRODUCTION_KEY_STATUS,
  UPDATE_CREATOR_LINKAGE_MODULE_STATUS,
};
